import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

export function useCreateSale() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await api.post('/pos/sales', body);
      return data?.invoice || data?.data || data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['pos', 'products'] });
      qc.invalidateQueries({ queryKey: ['sessions', 'active'] });
    }
  });
}
